/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button, Stack, Paper, Typography, Divider, Grid, Box } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import HistoryIcon from '@mui/icons-material/History';
import { Formik } from "formik";
import get from "lodash/get";
import map from "lodash/map";
import isEmpty from "lodash/isEmpty";
import LogsModal from "./LogsModal";
import FilesModalClient from "./FilesModalClient";

import Switch from "../../../components/form/Switch";
import InputText from "../../../components/form/InputText";
import Autocomplete from "../../../components/form/AutoComplete";
import Notification from "../../../components/form/Notification";
import Alert from "../../../components/form/Alert";
import validator from "./validator";
import { useCanView } from "../../../config/hook/UserPermissions";

import { getClientId } from "../../../store/masters/thunk/client/getId";
import { putClient } from "../../../store/masters/thunk/client/put";
import { getLog } from "../../../store/config/thunk/log/getAll";
import { getClientOdoo } from "../../../store/masters/thunk/client/getAllOdoo";

const NewEdit = ({ setBtns }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [__] = useTranslation("client");
  const [openModal, setOpenModal] = useState(false);
  const [showGalery, setShowGalery] = useState(false);
  const { id } = useParams();
  const [showNoti, setShowNoti] = useState({ open: false, msg: "", variant: "error", action: "put" });
  const [alert, setAlert] = useState({ open: false, title: "", subtitle: "", type: "" });
  const canView = useCanView();

  const current = useSelector((state) => state.masters.client.detail);
  const put = useSelector((state) => state.masters.client.put);
  const clientsOdoo = useSelector((state) => state.masters.client.clientsOdoo);

  const userData = JSON.parse(localStorage.getItem('userData'));

  const municipalities = map(userData?.municipalities, ({ municipalityId, municipalityName }) => ({
    value: municipalityId,
    label: municipalityName,
  }))

  const departments = map(userData?.departments, ({ departmentId, description }) => ({
    value: departmentId,
    label: description,
  }))

  const optionsClientOdoo = map(get(clientsOdoo, "data.result", []), ({ id, name }) => ({
    value: id,
    label: `${id} - ${name}`,
  }))

  const closeAlert = () => {
    setAlert({ open: false, title: "", subtitle: "", type: "", btn: "" });
  };

  const setError = (err) => {
    if (!isEmpty(err) && !!get(err, "Message", "")) {
      setAlert({
        open: true,
        title: get(err, "Message", ""),
        subtitle: (
          <ul>{map(get(err, "ValidationError", []), (item) => <li>{`• ${item}`}</li>)}</ul>
        ),
        type: "error",
        func: closeAlert,
      });
    } else {
      setAlert({ open: true, type: "default", func: closeAlert });
    }
  };

  useEffect(() => {
    if (get(put, "isSuccess", false)) {
      setShowNoti({ open: true, msg: "", variant: "success", action: "put" });
    }
    if (get(put, "isReject", false)) {
      setError(get(put, "error", {}));
    }
  }, [put]);

  useEffect(() => {
    if (!get(clientsOdoo, "isSuccess", false)) {
      dispatch(getClientOdoo());
    }
    if (!!id) {
      dispatch(getLog({ page: 1, maeId: String(id), screen: "CLIENTES/" }));
      dispatch(getClientId({ id }));
    }
  }, [dispatch, id]);

  const onSubmit = (values) => {
    if (canView("MAESTROS/CLIENTES", "update")) {
      dispatch(putClient({
        customerId: id,
        name: values.name,
        address: values.address,
        city: values.city,
        municipality: values.municipality || 0,
        department: values.department || 0,
        isActive: values.isActive ? 1 : 0,
        phone: values.phone,
        email: values.email,
        clientOdooId: values.clientOdooId || 0,
      }));
    } else {
      setAlert({
        open: true,
        title: "Permiso Denegado.",
        subtitle: (<ul> • No tienes permiso para actualizar el cliente.</ul>),
        type: "error",
        func: closeAlert,
      });
    }
  };

  const initialValues = {
    isActive: get(current, "data.isActive", 1) === 1,
    customerId: get(current, "data.customerID", id) || id,
    name: get(current, "data.name", ""),
    address: get(current, "data.address", ""),
    city: get(current, "data.city", ""),
    municipality: get(current, "data.municipalityId", "") || "",
    department: get(current, "data.departmentId", "") || "",
    phone: get(current, "data.phone", ""),
    email: get(current, "data.email", ""),
    clientOdooId: get(current, "data.clienteOdooId", "") || "",
  };

  useEffect(() => {
    setBtns(
      <Stack className="mr-6" direction="row" spacing={2} justifyContent="flex-end">
        <Button
          className="w-[150px] min-w-[150px]"
          variant="outlined"
          color="secondary"
          startIcon={<HistoryIcon />}
          onClick={() => {
            if (canView("MAESTROS/CLIENTES/LOGS", "watch")) {
              setOpenModal(true)
            } else {
              setAlert({
                open: true,
                title: "Permiso Denegado.",
                subtitle: (<ul> • No tienes permiso para ver las modificaciones en clientes.</ul>),
                type: "error",
                func: closeAlert
              })
            }
          }}
        >
          Ver Cambios
        </Button>
        <Button className='w-[100px] min-w-[100px]' variant='text' color="secondary" onClick={() => {
          if (canView("MAESTROS/CLIENTES/ADJUNTOS", "watch")) {
            setShowGalery(true)
          } else {
            setAlert({
              open: true,
              title: "Permiso Denegado.",
              subtitle: (<ul> • No tienes permiso para ver los adjuntos del cliente.</ul>),
              type: "error",
              func: closeAlert
            })
          }
        }} disabled={get(put, "isLoading")} >
          <div className='whitespace-nowrap'>Ver Adjuntos</div>
        </Button>
        <LoadingButton
          form="form-client"
          type="submit"
          variant="contained"
          color="secondary"
          loading={get(put, "isLoading")}
          className="w-[120px] min-w-[120px]"
        >
          {__(`action.save`)}
        </LoadingButton>
        <Button
          className="w-[100px] min-w-[100px]"
          variant="outlined"
          color="secondary"
          onClick={() => navigate("/masters/clients")}
          disabled={get(put, "isLoading")}
        >
          {__(`action.cancel`)}
        </Button>
      </Stack>
    );
  }, [get(put, "isLoading")]);

  const isLoading = get(current, "isLoading", false) || get(put, "isLoading", false);

  return (
    <div>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validator(__)}
        onSubmit={onSubmit}
      >
        {(formik) => (
          <form id="form-client" onSubmit={get(formik, "handleSubmit")}>
            <Paper className="mt-4">
              <Stack className="p-4" direction="row" spacing={2} justifyContent="space-between">
                <Typography component="h4" variant="h4">{__(`labels.1`)}</Typography>
                <Switch formik={formik} name="isActive" __={__} />
              </Stack>
              <Divider />
              <Box className="p-4">
                <Grid container spacing={{ xs: 2, md: 3 }}>
                  <Grid item xs={12} sm={6}>
                    <InputText
                      formik={formik}
                      name="customerId"
                      label={__(`form.customerId.label`)}
                      disabled
                      readOnly
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <InputText
                      formik={formik}
                      name="name"
                      label={__(`form.name.label`)}
                      disabled={isLoading}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <InputText
                      formik={formik}
                      name="phone"
                      label={__(`form.phone.label`)}
                      disabled={isLoading}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <InputText
                      formik={formik}
                      name="email"
                      label={__(`form.email.label`)}
                      disabled={isLoading}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography className="pt-4" component="p" variant="bmr" color="text.lite">
                      {__(`labels.3`)}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <InputText
                      formik={formik}
                      name="address"
                      label={__(`form.address.label`)}
                      disabled={isLoading}
                      multiline
                      rows={4}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <InputText
                      formik={formik}
                      name="city"
                      label={__(`form.city.label`)}
                      disabled={isLoading}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Autocomplete
                      formik={formik}
                      name="department"
                      label={__(`form.department.label`)}
                      placeholder={__(`form.department.label`)}
                      disabled={isLoading}
                      options={departments}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Autocomplete
                      formik={formik}
                      name="municipality"
                      label={__(`form.municipality.label`)}
                      placeholder={__(`form.municipality.label`)}
                      disabled={isLoading}
                      options={municipalities}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Autocomplete
                      formik={formik}
                      name="clientOdooId"
                      label={__(`form.clientOdooId.label`)}
                      placeholder={__(`form.clientOdooId.label`)}
                      disabled={isLoading}
                      loading={get(clientsOdoo, "isLoading")}
                      options={optionsClientOdoo}
                    />
                  </Grid>
                </Grid>
              </Box>
            </Paper>
          </form>
        )}
      </Formik>
      <Notification __={__} showNoti={showNoti} setShowNoti={setShowNoti} />
      <LogsModal __={__} open={openModal} close={() => setOpenModal(false)} />
      <FilesModalClient __={__} open={showGalery} close={() => setShowGalery(false)} />
      <Alert
        title={get(alert, "title")}
        subtitle={get(alert, "subtitle")}
        btn1={{ func: get(alert, "func") }}
        btn2={{}}
        type={get(alert, "type")}
        openAlert={get(alert, "open")}
        closeAlert={closeAlert}
      />
    </div>
  );
};

export default NewEdit;
